import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Nomor Polisi", -1)
const _hoisted_3 = { class: "invalid-feedback" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Nomor Lambung", -1)
const _hoisted_6 = { class: "invalid-feedback" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Type/Karoseri Bus", -1)
const _hoisted_9 = { class: "invalid-feedback" }
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Kategori Kendaraan", -1)
const _hoisted_12 = { class: "invalid-feedback" }
const _hoisted_13 = { class: "mb-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Kapasitas Bus", -1)
const _hoisted_15 = { class: "invalid-feedback" }
const _hoisted_16 = { class: "mb-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "Warna", -1)
const _hoisted_18 = { class: "invalid-feedback" }
const _hoisted_19 = { class: "mb-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Tahun Pembuatan", -1)
const _hoisted_21 = { class: "invalid-feedback" }
const _hoisted_22 = { class: "mb-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Nomor STNK", -1)
const _hoisted_24 = { class: "invalid-feedback" }
const _hoisted_25 = { class: "mb-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Nomor BPKB", -1)
const _hoisted_27 = { class: "invalid-feedback" }
const _hoisted_28 = { class: "mb-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "Keterangan", -1)
const _hoisted_30 = { class: "mb-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm mb-1" }, "Aktif", -1)
const _hoisted_32 = { class: "container-btn-action" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Kembali")

import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'
import Button from 'primevue/button'
import { Form, Field } from 'vee-validate'
import * as Yup from 'yup'
import { useStore } from 'vuex'
import InputSwitch from 'primevue/inputswitch'
import { onMounted, ref, reactive, getCurrentInstance, computed } from 'vue'
import type { Ref } from 'vue'
import {
  IVehicleForm
} from '@/utils/interfaces/iVehicle'
import IResponse from '@/utils/interfaces/iResponse'
import apiUseCase from '@/usecase/apiUseCase'
import { isNull } from 'lodash'
import HjpCofirmModal from '@/views/components/modal/HjpConfirmationModal.vue'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import rgxExp from '@/utils/helpers/regExp'


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const moduleStore = 'hjpTable'
const endpoint = '/management/v1/MsVehicle'

const store = useStore()
const app = getCurrentInstance()
const {
  $toast, $strInd
} = app!.appContext.config.globalProperties
const titleButton = ref('Simpan Kendaraan')
const isUpdate = ref(false)
const idPrams = computed(() => store.state[moduleStore]?.modal?.data?.Id)
const dataForm = ref()
const isLoading = ref(true)
const vehicleCategories = ref([])

const fetchVehicleCategories = async () => {
  try {
    const res = await apiUseCase.get(`${endpoint}/VehicleCategories`)
    if (!res.error && Array.isArray(res.result)) {
      vehicleCategories.value = res.result.map((category: any) => ({
        label: category.Name,
        value: category.Name
      }))
    }
  } catch (error) {
    console.error('Error fetching vehicle categories:', error)
  }
}

const initialValues: Ref<IVehicleForm> = ref({
  Nopol: '',
  HullNumber: '',
  Type: '',
  VehicleCategory: null,
  SeatCapacity: 1,
  Colours: '',
  PurchasedAt: '',
  Stnk: '',
  Bpkb: '',
  Description: '',
  IsActive: true
})

const schema = Yup.object().shape({
  Nopol: Yup.string().required('Nomor Polisi harus diisi!')
    .max(20, 'Nomor Polisi maksimal 20 karakter')
    .matches(/^[A-Za-z]{1,2}\s?[0-9]{1,4}\s?[A-Za-z]{1,3}$/, 'Format Nomor Polisi tidak valid (contoh: AG 1000 UXX)')
    .test('unique-nopol', 'Nomor Polisi sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['nopol']
        })}`)
        const filterResult = res.result.filter((x: any) => x.Nopol === val)
        if (idPrams.value) {
          return filterResult.length === 0 || val === initialValues.value.Nopol
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  HullNumber: Yup.string().required('Nomor Lambung harus diisi!')
    .max(7, 'Nomor Lambung maksimal 7 karakter')
    .matches(rgxExp.notSpaceChar, 'Nomor Lambung tidak valid')
    .test('unique-hullnumber', 'Nomor Lambung sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['hullnumber']
        })}`)
        const filterResult = res.result.filter((x: any) => x.HullNumber === val)
        if (idPrams.value) {
          return filterResult.length === 0 || val === initialValues.value.HullNumber
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  Type: Yup.string().required('Type/Karoseri Bus harus diisi!')
    .matches(rgxExp.notPrefixSpace, 'Type/Karoseri tidak valid')
    .max(50, 'Type/Karoseri Bus maksimal 50 karakter'),
  VehicleCategory: Yup.string().required('Kategori Kendaraan harus dipilih!'),
  Colours: Yup.string().max(20, 'Warna maksimal 20 karakter')
    .matches(rgxExp.notPrefixSpace, 'Warna tidak valid'),
  Stnk: Yup.string().required('Nomor STNK harus diisi!')
    .max(50, 'Nomor STNK maksimal 50 karakter')
    .matches(rgxExp.notSpaceChar, 'Nomor STNK tidak valid')
    .test('unique-stnk', 'Nomor STNK sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['stnk']
        })}`)
        const filterResult = res.result.filter((x: any) => x.Stnk === val)
        if (idPrams.value) {
          return filterResult.length === 0 || val === initialValues.value.Stnk
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  Bpkb: Yup.string().required('Nomor BPKB harus diisi!')
    .max(50, 'Nomor BPKB maksimal 50 karakter')
    .matches(rgxExp.notSpaceChar, 'Nomor BPKB tidak valid')
    .test('unique-bpkb', 'Nomor BPKB sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['bpkb']
        })}`)
        const filterResult = res.result.filter((x: any) => x.Bpkb === val)
        if (idPrams.value) {
          return filterResult.length === 0 || val === initialValues.value.Bpkb
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  PurchasedAt: Yup.string().required('Tahun Pembuatan harus diisi!').max(4, 'Tahun Pembuatan maksimal 4 karakter')
    .test('maxDigits', 'Tahun Pembuatan tidak valid', (value) => {
      const valConfert = value.toString()
      if (!valConfert) return true
      const numberRegex = /^\d{1,4}?$/
      console.log(numberRegex.test(valConfert))
      return numberRegex.test(valConfert)
    }),
  SeatCapacity: Yup.number().required('Kapasitas Bus harus diisi!')
    .typeError('Kapasitas Bus tidak valid')
    .test('maxDigits', 'Kapasitas Bus tidak valid', (value) => {
      console.log('val', value)
      const valConfert = value.toString()
      // if (!valConfert) return true
      const numberRegex = /^[0-9]*$/
      return numberRegex.test(valConfert)
    })
    .max(999, 'Kapasitas Bus maksimal 3 digit')
    .min(1, 'Kapasitas Bus minimal 1')
})

const attrModalConfirmation = reactive({
  show: false,
  title: '',
  subTitle: '',
  btnSubmitTitle: '',
  imgContent: require('@/assets/img/modal-confirmation/vehicle-add-update.svg')
})

const onSubmit = (values: any) => {
  dataForm.value = values
  attrModalConfirmation.show = true
}

const hideDialogConfirmation = () => {
  attrModalConfirmation.show = false
}

const onSubmitConfirmation = async () => {
  const toastMessage = isUpdate.value ? 'Data berhasil diubah' : 'Data berhasil ditambahkan'
  // console.log('aaaa')
  try {
    const response = !isUpdate.value ? await apiUseCase.postOrPut(endpoint, null, dataForm.value) : await apiUseCase.postOrPut(endpoint, store.state.hjpTable.modal.data.Id, dataForm.value)
    if (!response.error) {
      store.dispatch('setShowModal', false)
      store.dispatch('setReloadDataTable', true)
      $toast.add({
        severity: 'success',
        detail: toastMessage,
        group: 'bc',
        closable: false,
        life: 3000
      })
    } else {
      $toast.add({
        severity: 'error',
        detail: response.message,
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  } catch (error) {
    $toast.add({
      severity: 'error',
      detail: toastMessage,
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
}

const hideSidebar = () => {
  store.dispatch('setShowModal', false)
}

const getDetailForm = (id: string) => {
  apiUseCase.get(`${endpoint}/${id}`).then((res: IResponse) => {
    console.log('response', res)
    const {
      result
    } = res
    initialValues.value = result
    console.log('data', initialValues.value)
    isLoading.value = false
  }).catch((err: any) => {
    console.log('err', err)
  })
}

const checkAddOrUpdate = () => {
  if (store.state[moduleStore].modal.data) {
    attrModalConfirmation.title = 'Simpan Perubahan Kendaraan?'
    attrModalConfirmation.subTitle = 'Pastikan data kendaraan / bus sudah benar dan sesuai dengan yang Anda inginkan.'
    attrModalConfirmation.btnSubmitTitle = titleButton.value
    isUpdate.value = true
    if (store.state[moduleStore].modal.data.Id) {
      getDetailForm(store.state[moduleStore].modal.data.Id)
    }
  } else {
    attrModalConfirmation.title = 'Tambahkan Kendaraan?'
    attrModalConfirmation.subTitle = 'Pastikan data kendaraan / bus sudah benar dan sesuai dengan yang Anda inginkan.'
    attrModalConfirmation.btnSubmitTitle = titleButton.value
    isLoading.value = false
  }
}

onMounted(() => {
  fetchVehicleCategories()
  let titleForm = 'Tambah'
  if (store.state[moduleStore].modal.data) {
    titleForm = 'Edit'
    titleButton.value = 'Simpan perubahan'
  }
  checkAddOrUpdate()
  store.dispatch('setTitleFormSidebar', `${titleForm} Kendaraan`)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!isLoading.value)
      ? (_openBlock(), _createBlock(_unref(Form), {
          key: 0,
          onSubmit: onSubmit,
          "validation-schema": _unref(schema),
          "initial-values": initialValues.value,
          class: "form-container"
        }, {
          default: _withCtx(({ errors, values, setFieldValue }) => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(_unref(Field), { name: "Nopol" }, {
                default: _withCtx(({ field, handleChange, handleBlur }) => [
                  _createVNode(_unref(InputText), _mergeProps(field, {
                    onChange: handleChange,
                    onBlur: handleBlur,
                    class: `input-primary ${errors.Nopol ? 'input-invalid' : ''}`,
                    placeholder: "Ex. AG 1000 UXX",
                    maxlength: 20
                  }), null, 16, ["onChange", "onBlur", "class"])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_3, _toDisplayString(errors.Nopol), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_unref(Field), { name: "HullNumber" }, {
                default: _withCtx(({ field, handleChange, handleBlur }) => [
                  _createVNode(_unref(InputText), _mergeProps(field, {
                    onChange: handleChange,
                    onBlur: handleBlur,
                    class: `input-primary ${errors.HullNumber ? 'input-invalid' : ''}`,
                    placeholder: "Ex. 1023910429343",
                    maxlength: 10
                  }), null, 16, ["onChange", "onBlur", "class"])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_6, _toDisplayString(errors.HullNumber), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_unref(Field), { name: "Type" }, {
                default: _withCtx(({ field, handleChange, handleBlur }) => [
                  _createVNode(_unref(InputText), _mergeProps(field, {
                    onChange: handleChange,
                    onBlur: handleBlur,
                    class: `input-primary ${errors.Type ? 'input-invalid' : ''}`,
                    placeholder: "Ex. Adi Putro",
                    maxlength: 50
                  }), null, 16, ["onChange", "onBlur", "class"])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_9, _toDisplayString(errors.Type), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_unref(Field), { name: "VehicleCategory" }, {
                default: _withCtx(({ handleBlur }) => [
                  _createVNode(_unref(Dropdown), {
                    optionLabel: "label",
                    optionValue: "value",
                    id: "vehicle-category",
                    options: vehicleCategories.value,
                    placeholder: "Pilih Kategori Kendaraan",
                    class: "w-full input-primary",
                    onBlur: handleBlur,
                    onChange: (val) => setFieldValue('VehicleCategory', val.value),
                    modelValue: values.VehicleCategory,
                    "onUpdate:modelValue": ($event: any) => ((values.VehicleCategory) = $event)
                  }, null, 8, ["options", "onBlur", "onChange", "modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_12, _toDisplayString(errors.VehicleCategory), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_unref(Field), { name: "SeatCapacity" }, {
                default: _withCtx(({ field, handleChange, handleBlur }) => [
                  _createVNode(_unref(InputText), _mergeProps(field, {
                    onChange: handleChange,
                    onBlur: handleBlur,
                    type: "number",
                    class: `input-primary ${errors.SeatCapacity ? 'input-invalid' : ''}`,
                    placeholder: "ex. 45",
                    min: 1,
                    minlength: 1,
                    maxlength: 3
                  }), null, 16, ["onChange", "onBlur", "class"])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_15, _toDisplayString(errors.SeatCapacity), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_unref(Field), { name: "Colours" }, {
                default: _withCtx(({ field, handleChange, handleBlur }) => [
                  _createVNode(_unref(InputText), _mergeProps(field, {
                    onChange: handleChange,
                    onBlur: handleBlur,
                    class: `input-primary ${errors.Colours ? 'input-invalid' : ''}`,
                    placeholder: "Ex. Merah",
                    maxlength: 20
                  }), null, 16, ["onChange", "onBlur", "class"])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_18, _toDisplayString(errors.Colours), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_unref(Field), { name: "PurchasedAt" }, {
                default: _withCtx(({ field, handleChange, handleBlur }) => [
                  _createVNode(_unref(InputText), _mergeProps(field, {
                    onChange: handleChange,
                    onBlur: handleBlur,
                    type: "number",
                    class: `input-primary ${errors.PurchasedAt ? 'input-invalid' : ''}`,
                    placeholder: "ex. 2020",
                    min: 0,
                    maxlength: 4
                  }), null, 16, ["onChange", "onBlur", "class"])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_21, _toDisplayString(errors.PurchasedAt), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode(_unref(Field), { name: "Stnk" }, {
                default: _withCtx(({ field, handleChange, handleBlur }) => [
                  _createVNode(_unref(InputText), _mergeProps(field, {
                    onChange: handleChange,
                    onBlur: handleBlur,
                    class: `input-primary ${errors.Stnk ? 'input-invalid' : ''}`,
                    placeholder: "ex. 1231341231",
                    maxlength: 50
                  }), null, 16, ["onChange", "onBlur", "class"])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_24, _toDisplayString(errors.Stnk), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_unref(Field), { name: "Bpkb" }, {
                default: _withCtx(({ field, handleChange, handleBlur }) => [
                  _createVNode(_unref(InputText), _mergeProps(field, {
                    onChange: handleChange,
                    onBlur: handleBlur,
                    class: `input-primary ${errors.Bpkb ? 'input-invalid' : ''}`,
                    placeholder: "ex. 1231341231",
                    maxlength: 50
                  }), null, 16, ["onChange", "onBlur", "class"])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_27, _toDisplayString(errors.Bpkb), 1)
            ]),
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode(_unref(Field), {
                name: "Description",
                as: "textarea",
                class: "input-primary",
                placeholder: "Tulis Keterangan"
              })
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createVNode(_unref(Field), { name: "IsActive" }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_unref(InputSwitch), _mergeProps({ class: "input-success" }, field, {
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                    inputId: "isactive",
                    disabled: values.IsUsed
                  }), null, 16, ["modelValue", "onUpdate:modelValue", "disabled"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_unref(Button), {
                class: "btn-back mr-2",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (hideSidebar()))
              }, {
                default: _withCtx(() => [
                  _hoisted_33
                ]),
                _: 1
              }),
              _createVNode(_unref(Button), {
                type: "submit",
                class: "btn-primary mr-1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(titleButton.value), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["validation-schema", "initial-values"]))
      : _createCommentVNode("", true),
    _createVNode(HjpCofirmModal, {
      show: attrModalConfirmation.show,
      imgContent: attrModalConfirmation.imgContent,
      title: attrModalConfirmation.title,
      subTitle: attrModalConfirmation.subTitle,
      btnSubmitTitle: attrModalConfirmation.btnSubmitTitle,
      onHideDialog: hideDialogConfirmation,
      onOnSubmit: onSubmitConfirmation
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle"])
  ]))
}
}

})